import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const TIME_ZONE = 'Europe/Tallinn';

export function formatDateTime(date: string) {
  return formatDate(date, 'dd.MM.yyyy | HH:mm');
}

export function formatClock(date: string) {
  return formatDate(date, 'HH:mm');
}

export function formatClockless(date: any) {
  return formatDate(date, 'dd.MM.yyyy');
}

export function formatDate(date: string, formatFormula: string, currentLocale?: Locale) {
  return date ? format(toTimeZone(date as any), formatFormula, currentLocale ? {
    locale: currentLocale
  } : {}) : '';
}

function toTimeZone(date: Date): Date {
  return utcToZonedTime(date, TIME_ZONE);
}